<template>
    <el-dialog
            title="学生添加/编辑/查看"
            :visible.sync="dialogVisible"
            width="600px"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            append-to-body>
        <el-form ref="form" :model="form" label-width="180px">
            <el-form-item label="招生单位/人员" v-if="status == 2">
                <label style="color: #409EFF">{{form.creatorUsername}}</label>
            </el-form-item>
            <el-form-item
                    v-for="(item,index) in form.items"
                    :key="item.id"
                    :label="item.formItem.name"
                    :required="item.formItem.required == 1"
            >
                <div class="item-style" v-if="status!=2">
                    <el-input v-if="item.formItem.type == 1 && status ==1 " v-model="form.items[index].value" :readonly="item.formItem.id == 1 " :placeholder="item.formItem.note" clearable></el-input>
                    <el-input v-else-if="item.formItem.type == 1 && status ==0" v-model="form.items[index].value"  :placeholder="item.formItem.note" clearable></el-input>
<!--                    <el-input v-if="item.formItem.type == 1" v-model="form.items[index].value"  :placeholder="item.formItem.note" clearable></el-input>-->
                    <el-select v-else-if="item.formItem.type == 2" v-model="form.items[index].value" :placeholder="item.formItem.note" clearable @change="flushPage">
                        <el-option
                                v-for="it in item.formItem.ruleConfig.split(',')"
                                :key="it"
                                :label="it"
                                :value="it">
                        </el-option>
                    </el-select>
                    <el-input v-else-if="item.formItem.type == 3" v-model="form.items[index].value" :placeholder="item.formItem.note" clearable></el-input>
                    <el-input v-else-if="item.formItem.type == 4" v-model="form.items[index].value" :maxlength="item.formItem.ruleConfig" :placeholder="item.formItem.note" clearable></el-input>
                    <el-input v-else-if="item.formItem.type == 5" v-model="form.items[index].value" :maxlength="item.formItem.ruleConfig" :placeholder="item.formItem.note" clearable></el-input>
                    <div v-else-if="(item.formItem.type == 6 || item.formItem.type == 7) && (form.items[index].value == null || form.items[index].value == undefined) ">
                        <el-upload
                                :action="uploadUrl"
                                :http-request="uploadFile"
                                :before-upload="(file) => beforeFileUpload(file,item.formItem.type,index)"
                                :data="postData"
                                :show-file-list="false">
                            <el-button type="primary">上传文件</el-button>
                        </el-upload>
                    </div>
                    <div v-else>
                        <div class="img-box"  v-if="item.formItem.type == 6">
                            <img :src="form.items[index].value" @click="submitFile(index,item.formItem.type)">
                            <el-button type="info" icon="el-icon-delete" plain @click="deleteImg(index)" circle v-if="deleteImgState == 1"></el-button>
                        </div>

                        <div v-else class="link-box1">
                            <el-link
                                    :underline="false"
                                    type="primary"
                                    :disabled="!form.items[index].value"
                                    :href="form.items[index].value"
                                    v-if="allowAction.indexOf('download') != -1">
                                {{getFileName(index)}}
                            </el-link>
                            <el-button style="color: #F56C6C;margin-left: 10px" type="text" @click="submitFile(index,item.formItem.type)">修改</el-button>
                            <el-button style="color: #F56C6C;margin-left: 10px" type="text" @click="deleteFile(index)">删除</el-button>
                        </div>
                    </div>
                </div>
                <div class="item-style" v-else>
                    <el-input v-if="item.formItem.type != 6 && item.formItem.type != 7" readonly v-model="form.items[index].value" ></el-input>
                    <div v-else-if="item.formItem.type == 6" class="img-box">
                        <el-image :src="form.items[index].value" v-if="form.items[index].value" :preview-src-list="previewImg"/>
                        <label v-else>暂无图片</label>
                    </div>
                    <div v-else class="link-box">
                        <el-link type="primary" :underline="false" :href="form.items[index].value" v-if="form.items[index].value">下载文件</el-link>
                        <label v-else>暂无文件</label>
                    </div>
                </div>
            </el-form-item>
        </el-form>
        <div class="flex-middle flex-center">
            <el-button plain @click="resetForm" v-show="status != 2">重置</el-button>
            <el-button plain @click="dialogVisible = false;$emit('fetchData')">取消</el-button>
            <el-button type="primary" @click="submit" v-show="status != 2">保存</el-button>
        </div>
        <el-upload
                :action="uploadUrl"
                :http-request="uploadFile"
                :data="postData"
                :show-file-list="false"
                style="display: none"
        >
            <el-button type="primary" id="common-upload">上传文件</el-button>
        </el-upload>
    </el-dialog>
</template>

<script type="text/javascript">
    import Upload from '@/assets/js/Upload.js'
    import Utils from "../../../assets/js/Utils";

    export default {
        name: 'AddDataDialog',
        props: ['successCallback'],
        data() {
            return {
                dialogVisible: false,
                allowAction: [],
                dataId: null,
                form: {
                    id: null,
                    items: []
                },
                status: null, // 0-添加 1-修改 2-查看

                itemList: [],

                uploadUrl: Urls.URL.upload_url, // 文件上传地址
                postData: {},
                fileUploadIndex: null,
                fileUploadType: null,
                previewImg: [],
                tempFilename: [],
                deleteImgState:1,
            }
        },
        watch: {
            dialogVisible(newVal, oldVal) {
                if (newVal == false) {
                    Object.assign(this.$data, this.$options.data())
                }
            }
        },
        methods: {
            deleteImg(index){
              this.form.items[index].value = null
              this.deleteImgState = 0
            },
            deleteFile(index){
              this.form.items[index].value = null
            },
            getFileName(index) {
                let i = this.tempFilename.findIndex(res => res.index == index)
                if(i != -1) {
                    return this.tempFilename[i].name
                }else {
                    return this.form.items[index].value.substring(this.form.items[index].value.lastIndexOf('/')+1)
                }
            },

            // 显示弹出层
            async setMaskVisible(val, data , status) {
                await this.fetchData()
                this.allowAction = Utils.checkMenuOprate('enroll.data')
                this.dialogVisible = val
                // 暴力深拷贝
                let _obj = JSON.stringify(data);
                this.form = JSON.parse(_obj);
                // 当对象中只有一级属性，没有二级属性的时候，此方法为深拷贝，但是对象中有对象的时候，此方法，在二级属性以后就是浅拷贝
                // this.form  = Object.assign({},data)
                if(!this.form.id) {
                    this.form.items = []
                }
                this.status = status
                this.dataId = this.form.id
                this.form  = Object.assign({},this.form)
                console.log('this.form',this.form)
            },

            fetchData() {
                let params = {
                    pageSize: 1000,
                    pageNum: 1,
                }
                axios.get(Urls.URL.form_url, {params}).then(res => {
                    if(res.status == '200') {
                        this.itemList = res.data.data.rows
                        for(let i=0;i<this.itemList.length;i++) {
                            let item = this.itemList[i]
                            if(!this.form.id) {
                                this.form.items.push({formItemId:item.id,formItem:item,value:null})
                            } else {
                                let flag = this.form.items.find(res => {
                                    return res.formItemId === item.id
                                })
                                if(flag) {
                                    continue
                                }
                                this.form.items.push({formItemId:item.id,formItem:item,value:null})
                            }
                        }
                        this.form.items.forEach(item => {
                            if(item.formItem.type == 6 && item.value) {
                                this.previewImg.push(item.value)
                            }
                        })
                    }
                }).catch(err => {
                    this.$alert(err || err.response.data.errorMessage || Utils.errorText)
                })
            },

            // 批量导入
            // 提交文件之前，设置post参数
            beforeFileUpload(file,type, i) {    //在图片提交前进行验证
                let index = file.name.lastIndexOf('.')
                let suffix = file.name.substring(index + 1)
                if(type == 6) {
                    const isExcel = suffix === 'jpg' || suffix === 'jpeg' || suffix === 'png'
                    if (!isExcel) this.$message.error('只能上传jpg/png格式的图片');
                    else {
                        this.fileUploadIndex = i
                        this.fileUploadType = type
                    }
                    return isExcel
                } else{
                    this.fileUploadIndex = i
                    this.fileUploadType = type
                    return true // 任意文件
                }
            },

            submitFile(index,type) {
                this.fileUploadIndex = index
                this.fileUploadType = type
                document.getElementById('common-upload').click()
            },

            // 上传文件方法
            uploadFile(item) {
                let file = item.file
                let suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
                let type = this.fileUploadType
                if(type == 6) {
                    const isPic = suffix === 'jpg' || suffix === 'jpeg' || suffix === 'png'
                    if (!isPic) this.$message.error('只能上传jpg/png格式的图片');
                }else if(type == 7) {
                    let index = this.tempFilename.findIndex(res => res.index == this.fileUploadIndex)
                    if(index != -1) {
                        this.tempFilename[index].name = file.name
                    } else {
                        this.tempFilename.push({index:this.fileUploadIndex,name:file.name})
                    }
                }
                Upload.uploadFile(file).then((url, pathName) => {
                    this.form.items[this.fileUploadIndex].value = url
                    this.form.items[this.fileUploadIndex] = Object.assign({},this.form.items[this.fileUploadIndex])
                    this.form.items = Object.assign([],this.form.items)
                    this.deleteImgState = 1
                }).catch(err => {
                    this.$message.warning("上传失败，请稍后再试！")
                })
            },

            resetForm() {
                this.form = Object.assign({})
                this.form.items = []
                this.form.id = this.dataId
            },

            submit() {
                let url = Urls.URL.data_url
                for(let i=0;i<this.form.items.length;i++) {
                    let item = this.form.items[i]
                    if(item.formItem.required ==1 && !item.value) {
                        this.$message.error(`${item.formItem.name}的值不能为空`)
                        return
                    }
                    if(item.value && item.formItem.type == 1 && item.formItem.ruleConfig) {
                        if(item.formItem.ruleConfig.indexOf(',') != -1) {
                            if(item.formItem.ruleConfig.indexOf(item.value) == -1) {
                                this.$message.error(`${item.formItem.name}文本规则中没有您所填的值}`)
                                return
                            }
                        } else {
                            if(item.value.length > parseInt(item.formItem.ruleConfig)) {
                                this.$message.error(`${item.formItem.name}输入的值超过规定长度,可输入最大：${item.formItem.ruleConfig}`)
                                return
                            }
                        }

                    }
                    if(item.value && item.formItem.type == 3) {
                        if(!Utils.isNationalNoPattern.test(item.value)) {
                            this.$message.error('身份证号码格式不对')
                            return
                        }
                    }
                    if(item.value && item.formItem.type == 4) {
                        if(!Utils.isPhonePattern.test(item.value)) {
                            this.$message.error('电话号码格式不对')
                            return
                        }
                    }
                }
                let params = Object.assign({},this.form)
                if(this.dataId) {
                    url = url + '/' + this.dataId
                }
                axios.post(url,params).then(res => {
                    this.dialogVisible = false
                    this.$emit('fetchData')
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

            flushPage(val) {
                this.form = Object.assign({},this.form)
            }

        }
    }
</script>

<style scoped lang="stylus">
    .dec-bc-style {
        flex: 1
        background-color: #F5F5F5
        >label {
            display inline-block
            margin-left 15px
        }
    }

    /deep/.el-select {
        width 100%
    }

    .img-box {
        width 80px
        display flex
        align-items center
        >img {
            width 100%
            margin-right 10px
        }
    }
    .link-box {
        width 80px
    }
    .link-box1 {
        width 100%
    }
</style>
